import { SessionRepository } from "@/repositories/session-repository.ts";

export default class SessionService {
    private static instance: SessionService;
    private readonly sessionRepo: SessionRepository;

    public static getInstance(sessionRepo: SessionRepository | undefined = undefined): SessionService {
        if (!SessionService.instance && sessionRepo) {
            SessionService.instance = new SessionService(sessionRepo);
        }
        if (this.instance.sessionRepo) {
            return SessionService.instance;
        }
        throw new Error("AuthService must be initialized with a userRepo before use.");
    }

    constructor(userRepo: SessionRepository) {
        this.sessionRepo = userRepo;
    }
}
